import React from 'react'
import { connect } from 'react-redux'
import { firebase, firestore } from './utilities/firebase'
import addUidToObject from './utilities/addUidToObject'
import styles from './HackMe.icss'

const firestoreSet = async (collectionId, documentId, document) => {
	try {
		await firestore.collection(collectionId)
			.doc(documentId)
			.set(addUidToObject(document))
		console.log('HACKED')
	} catch (ex) {
		console.log('FOILED!', ex)
	}
}

const firestoreGet = async (collectionId, documentId) => {
	try {
		const doc = await firestore.collection(collectionId)
			.doc(documentId)
			.get()
		console.log('HACKED', doc.data())
	} catch (ex) {
		console.log('FOILED!', ex)
	}
}

class HackMe extends React.Component {
	render() {
		// Expose some fun stuff
		global.hackerTools = { firebase, firestore, addUidToObject, props: this.props, firestoreGet, firestoreSet }

		return (
			<div className={styles.wrapper}>
				<br />
				Have at it...
			</div>
		)
	}
}

export default connect(
	/* istanbul ignore next line */
	state => state
)(HackMe)



// WEBPACK FOOTER //
// ./src/HackMe.jsx